import { environment } from '../../environments/environment';

export class PlessURL {
  static URL = environment.apiURL;
  static ImageURL = environment.imageURL;
}
